/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `CASH` - Cash
* `THREE_MONTH_AVERAGE` - 3-month average
* `LOWEST` - Lowest of Cash and 3-month average
 */
export type CashOrThreeMonthEnum = typeof CashOrThreeMonthEnum[keyof typeof CashOrThreeMonthEnum];


export const CashOrThreeMonthEnum = {
  CASH: 'CASH',
  THREE_MONTH_AVERAGE: 'THREE_MONTH_AVERAGE',
  LOWEST: 'LOWEST',
} as const;
